import React from 'react';
import '../../styles/sevicesPages/strep&LabTestingStyle.css';
import '../../styles/app.css'
import labImg from '../../assets/lab-testing.jpg'; // Replace with a free stock lab image
import useScrollAnimation from '../../hooks/useScrollAnimation';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';

const StrepLabPage = () => {
    
    useScrollAnimation();

    const navigate = useNavigate();

  return (
    <>
    <Navbar/>
    <section className="strep-lab-page">
      
      {/* Hero Section */}
      <div className="hero-strep" style={{ backgroundImage: `url(${labImg})` }}>
        <div className="hero-overlay-strep fade-in">
          <h1>Strep & Lab Testing</h1>
          <p>Lab work request, strep throat testing, and results review services.</p>
        </div>
      </div>

      {/* Info Section */}
      <div className="info-section">
        <h2 className='fade-in-delay-2'>Why Choose Our Lab Services?</h2>
        <div className="info-cards">
          <div className="card slide-up-delay-1">
            <i className="fas fa-vials"></i>
            <h3>Quick Testing</h3>
            <p>Fast strep throat and other lab tests with same-day results when possible.</p>
          </div>
          <div className="card slide-up-delay-2">
            <i className="fas fa-user-md"></i>
            <h3>Professional Review</h3>
            <p>Certified professionals review your lab results and provide guidance.</p>
          </div>
          <div className="card slide-up-delay-3">
            <i className="fas fa-file-medical-alt"></i>
            <h3>Secure Records</h3>
            <p>All lab results are securely stored and accessible anytime online.</p>
          </div>
        </div>
      </div>

      {/* Steps Section */}
      <div className="steps">
        <h2 className='fade-in-delay-2'>How It Works</h2>
        <div className="steps-cards">
          <div className="step-card step-1">
            <span>1</span>
            <h4>Request Lab Work</h4>
            <p>Submit your lab request online or in-store.</p>
          </div>
          <div className="step-card step-2">
            <span>2</span>
            <h4>Get Tested</h4>
            <p>Visit our pharmacy lab for strep throat and other testing.</p>
          </div>
          <div className="step-card step-3">
            <span>3</span>
            <h4>Receive Results</h4>
            <p>Review results securely online or with our pharmacist consultation.</p>
          </div>
        </div>
      </div>

      {/* Call-to-action Section */}
      <div className="cta-section">
        <h2 className='fade-in-delay-3'>Book Your Lab Test Today!</h2>
        <p className='fade-in-delay-3'>Ensure fast and accurate testing. Stay healthy and informed.</p>
        <button className="cta-btn slide-up" onClick={() => navigate("/book-appointment")}>Schedule Lab Test</button>
      </div>
    </section>
    <Footer/>
    </>
  );
};

export default StrepLabPage;
